import { render, staticRenderFns } from "./PageProjectList.vue?vue&type=template&id=011ba4c9"
import script from "./PageProjectList.vue?vue&type=script&lang=js"
export * from "./PageProjectList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports